import React from "react";
import Helmet from "react-helmet";

const CHARITY_NAME = process.env.REACT_APP_CHARITY_NAME || "Charity";

const CONVERT_EXPERIENCES_CHARITIES = new Set(["All Dogs Matter", "Dogs for Autism"]);
const shouldLoadConvertExperiments =
  CONVERT_EXPERIENCES_CHARITIES.has(CHARITY_NAME);


const MetaTags = ({
  title = `${CHARITY_NAME} Raffle House | Win Your Dream Home`,
  description = "Enter Raffle House`s Dream Draw & win the money to buy your Dream Home. Every purchase helps raise money for a charity close to your heart.",
  keywords = [""],
  canonical = process.env.REACT_APP_BASE_URL,
  robots = "follow, noindex",
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.filter(Boolean).join(", ")} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />

      {shouldLoadConvertExperiments && (
        <script
          type="text/javascript"
          src="https://cdn-4.convertexperiments.com/v1/js/10041529-100416224.js?environment=production"
        />
      )}
    </Helmet>
  );
};

export default MetaTags;
